import React from "react";
import logo from "../../../../assets/images/Logo.png";

const FieldRow = ({ label, value }) => (
  <div className="invoice-field-row">
    <span>{label}</span>
    <strong>{value || "N/A"}</strong>
  </div>
);

const PharmacyInvoiceTemplate = ({
  seller,
  buyer,
  invoice,
  items,
  footerData,
  amountInWords,
}) => {
  const taxRows = footerData?.taxDetails || [];
  const totals = footerData?.totals || {};

  return (
    <div className="pharmacy-invoice-page">
      <div className="pharmacy-invoice-sheet">
        <header className="clinic-header">
          <div className="clinic-logo-wrap">
            <img src={logo} alt="4Health Homeopathy" className="clinic-logo" />
          </div>

          <div className="clinic-identity">
            <h1>4HEALTH HOMEOPATHY - PHARMACY </h1>
            {/* <div className="clinic-subtitle">PHARMACY</div> */}
            <p>{seller.address}</p>
            <div className="clinic-contact-line">
              {seller.phone ? <span>Ph: {seller.phone}</span> : null}
              {seller.gstin ? <span>GSTIN: {seller.gstin}</span> : null}
              {/* {seller.dlNo ? <span>DL No: {seller.dlNo}</span> : null} */}
            </div>
          </div>

          <div className="invoice-badge-wrap">
            <div className="invoice-badge">Invoice</div>
            <div className="invoice-copy">ORIGINAL</div>
          </div>
        </header>

        <section className="info-grid">
          <div className="info-panel">
            <div className="panel-title">PATIENT DETAILS</div>
            <FieldRow label="Patient ID" value={buyer.his_no} />
            <FieldRow label="Patient Name" value={buyer.name} />
            <FieldRow label="Mobile" value={buyer.phone} />
          </div>

          <div className="info-panel invoice-info-panel">
            <div className="panel-title">INVOICE DETAILS</div>
            <FieldRow label="Invoice No" value={invoice.no} />
            <FieldRow label="Bill Date" value={invoice.date} />
            <FieldRow label="Payment" value={invoice.payments_types} />
            <FieldRow label="Billed By" value={invoice.billedBy} />
            {invoice.note ? <FieldRow label="Note" value={invoice.note} /> : null}
          </div>
        </section>

        <section className="medicine-section">
          <table className="medicine-table">
            <thead>
              <tr>
                <th className="text-center col-sn">#</th>
                <th>Medicine</th>
                <th>HSN</th>
                <th>Batch</th>
                <th>Expiry</th>
                <th className="text-center">Qty</th>
                <th className="text-end">Rate</th>
                <th className="text-end">GST %</th>
                <th className="text-end">Amount</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item) => (
                <tr key={item.sr}>
                  <td className="text-center">{item.sr}</td>
                  <td className="medicine-name">{item.description}</td>
                  <td>{item.hsn}</td>
                  <td>{item.batchNo}</td>
                  <td>{item.expDt || "-"}</td>
                  <td className="text-center">{item.qty}</td>
                  <td className="text-end">₹ {item.rate}</td>
                  <td className="text-end">{item.gst}</td>
                  <td className="text-end fw-bold">₹ {item.amount}</td>
                </tr>
              ))}
              {[...Array(Math.max(0, 15 - items.length))].map((_, index) => (
                <tr className="empty-row" key={`empty-${index}`}>
                  <td>&nbsp;</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>

        <section className="invoice-summary-grid">
          <div className="words-panel">
            <div className="panel-title">AMOUNT IN WORDS</div>
            <div className="amount-words">{amountInWords}</div>
            <div className="qty-line">
              Total Quantity: <strong>{totals.totalQty || 0}</strong>
            </div>
          </div>

          <div className="tax-panel">
            <div className="panel-title">GST SUMMARY</div>
            <table className="tax-table">
              <thead>
                <tr>
                  <th>GST</th>
                  <th>Taxable</th>
                  <th>SGST</th>
                  <th>CGST</th>
                  <th>Tax</th>
                </tr>
              </thead>
              <tbody>
                {taxRows.length ? (
                  taxRows.map((tax, index) => (
                    <tr key={index}>
                      <td>{tax.gst}</td>
                      <td>{tax.taxable}</td>
                      <td>{tax.sgst}</td>
                      <td>{tax.cgst}</td>
                      <td>{tax.tax}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center">No GST</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="totals-panel">
            <FieldRow label="Sub Total" value={`₹ ${totals.subtotal || "0.00"}`} />
            <FieldRow label="Discount" value={`₹ ${totals.discount || "0.00"}`} />
            <FieldRow
              label="CGST"
              value={`₹ ${Number(totals.cgstIgst || 0).toFixed(2)}`}
            />
            <FieldRow
              label="SGST"
              value={`₹ ${Number(totals.sgst || 0).toFixed(2)}`}
            />
            <FieldRow label="Round Off" value={`₹ ${totals.roundOff || "0.00"}`} />
            <div className="grand-total-row justify-content-between">
              <span></span>
              <strong className="text-center">₹ {totals.netAmount || "0.00"}</strong>
            </div>
          </div>
        </section>

        <footer className="invoice-footer">
          <div className="footer-note">
            <strong>Thank you for choosing 4Health Homeopathy.</strong>
            <span>This is a computer-generated pharmacy invoice.</span>
          </div>
          <div className="signature-box">
            <strong>For 4Health Homeopathy</strong>
            <div className="signature-space"></div>
            <span>Authorized Signature</span>
          </div>
        </footer>

        <div className="developer-credit">© Developed by Aalan Techsoft</div>
      </div>

      <style>{`
        .pharmacy-invoice-page {
          width: 100%;
          padding: 12px;
          background: #f4f7f7;
          color: #1d2b2d;
          font-family: Arial, Helvetica, sans-serif;
          box-sizing: border-box;
        }
        .pharmacy-invoice-sheet {
          width: 140mm;
          min-height: 190mm;
          margin: 0 auto;
          background: #fff;
          border: 1px solid #173f43;
          box-shadow: 0 4px 18px rgba(0, 0, 0, 0.08);
          box-sizing: border-box;
          overflow: hidden;
        }
        .clinic-header {
          display: grid;
          grid-template-columns: 110px 1fr 118px;
          align-items: center;
          gap: 10px;
          padding: 12px;
          border-bottom: 2px solid #01AEBE;
        }
        .clinic-logo-wrap { display: flex; align-items: center; justify-content: center; }
        .clinic-logo { width: 130px; height: auto; object-fit: contain; }
        .clinic-identity h1 {
          margin: 0;
          font-size: 14px;
          font-weight: 800;
          letter-spacing: 0.3px;
          color: #005b66;
        }
        .clinic-subtitle {
          font-size: 10px;
          font-weight: 800;
          letter-spacing: 2px;
          color: #555;
          margin: 2px 0 4px;
        }
        .clinic-identity p {
          margin: 0;
          font-size: 9px;
          line-height: 1.35;
          max-width: 330px;
        }
        .clinic-contact-line {
          margin-top: 2px;
          display: flex;
          flex-wrap: wrap;
          gap: 3px 10px;
          font-size: 8.5px;
          font-weight: 600;
        }
        .invoice-badge-wrap { text-align: right; align-self: stretch; display: flex; flex-direction: column; justify-content: center; }
        .invoice-badge {
          background: #01AEBE;
          color: white;
          padding: 8px 7px;
          border-radius: 4px;
          font-size: 11px;
          line-height: 1.2;
          text-align: center;
          font-weight: 800;
          letter-spacing: 0.3px;
        }
        .invoice-copy { text-align: center; font-size: 8px; font-weight: 700; margin-top: 4px; letter-spacing: 1px; }
        .info-grid { display: grid; grid-template-columns: 1.2fr 1fr; border-bottom: 1px solid #173f43; }
        .info-panel { padding: 2px 12px; max-height: 85px; }
        .info-panel + .info-panel { border-left: 1px solid #173f43; }
        .panel-title {
          font-size: 9px;
          font-weight: 800;
          color: #01AEBE;
          letter-spacing: 0.6px;
          margin-bottom: 6px;
        }
        .invoice-field-row { display: grid; grid-template-columns: 82px 1fr; gap: 6px; margin-bottom: 4px; font-size: 9.5px; line-height: 1.25; }
        .invoice-field-row > span:first-child { color: #5e6c6e; }
        .invoice-field-row strong { word-break: break-word; }
        .medicine-section { width: 100%; }
        .medicine-table, .tax-table { width: 100%; border-collapse: collapse; table-layout: fixed; }
        .medicine-table thead th {
          background: #01AEBE;
          color: #fff;
          font-size: 8.5px;
          padding: 6px 4px;
          border-right: 1px solid rgba(255,255,255,.32);
          vertical-align: middle;
        }
        .medicine-table tbody td {
          border-right: 1px solid #b8c5c7;
          border-bottom: 1px solid #cbd5d6;
          padding: 5px 4px;
          font-size: 8.5px;
          line-height: 1.2;
          vertical-align: middle;
          overflow-wrap: anywhere;
        }
        .medicine-table th:last-child, .medicine-table td:last-child { border-right: 0; }
        .medicine-table .col-sn { width: 10px; }
        .medicine-table th:nth-child(2) { width: 25%; }
        .medicine-table th:nth-child(3) { width: 8%; }
        .medicine-table th:nth-child(4) { width: 10%; }
        .medicine-table th:nth-child(5) { width: 10%; }
        .medicine-table th:nth-child(6) { width: 6%; }
        .medicine-table th:nth-child(7) { width: 9%; }
        .medicine-table th:nth-child(8) { width: 7%; }
        .medicine-table th:nth-child(9) { width: 12%; }
        .medicine-name { font-weight: 700; }
        .empty-row td { height: 17px; }
        .text-center { text-align: center; }
        .text-end { text-align: right; }
        .fw-bold { font-weight: 700; }
        .invoice-summary-grid {
          display: grid;
          grid-template-columns: 1.08fr 1.25fr 1fr;
          border-bottom: 1px solid #173f43;
        }
        .words-panel, .tax-panel, .totals-panel { padding: 8px; min-height: 115px; }
        .tax-panel, .totals-panel { border-left: 1px solid #173f43; }
        .amount-words { font-size: 9px; line-height: 1.45; font-weight: 700; text-transform: capitalize; }
        .qty-line { margin-top: 12px; font-size: 9px; }
        .tax-table th, .tax-table td { border: 1px solid #b8c5c7; padding: 4px 2px; font-size: 7.5px; text-align: right; }
        .tax-table th { background: #edf5f5; color: #274548; text-align: center; }
        .totals-panel .invoice-field-row { grid-template-columns: 1fr auto; margin-bottom: 5px; }
        .totals-panel .invoice-field-row strong { text-align: right; min-width: 70px; }
        .grand-total-row {
          margin: 7px -8px -8px;
          padding: 9px 8px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: #01AEBE;
          color: white;
          font-size: 10px;
          font-weight: 800;
        }
        .grand-total-row span, .grand-total-row strong { white-space: nowrap; }
        .grand-total-row strong { font-size: 18px; }
        .invoice-footer { display: grid; grid-template-columns: 1fr 170px; max-height: 65px; }
        .footer-note { padding: 10px 12px; display: flex; flex-direction: column; gap: 4px; font-size: 8.5px; color: #536264; }
        .footer-note strong { color: #173f43; }
        .signature-box { border-left: 1px solid #173f43; padding: 8px 12px; text-align: center; font-size: 8.5px; }
        .signature-space { height: 30px; }
        .developer-credit {
          padding: 3px 8px 4px;
          border-top: 1px solid #e3e9ea;
          text-align: center;
          font-size: 6.5px;
          line-height: 1.2;
          color: #7a8789;
          letter-spacing: 0.15px;
        }

        @media print {
          @page { size: A5 portrait; margin: 4mm; }
          html, body { margin: 0 !important; padding: 0 !important; background: white !important; }
          body { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
          .pharmacy-invoice-page { padding: 0 !important; background: white !important; }
          .pharmacy-invoice-sheet {
            width: 140mm !important;
            min-height: 0 !important;
            margin: 0 auto !important;
            border: 1px solid #173f43 !important;
            box-shadow: none !important;
            page-break-inside: avoid;
          }
          .clinic-header { padding: 9px; grid-template-columns: 96px 1fr 105px; }
          .clinic-logo { width: 88px; }
          .clinic-identity h1 { font-size: 17px; }
          .medicine-table thead th { background: #01AEBE !important; color: #fff !important; }
          .grand-total-row, .invoice-badge { background: #01AEBE !important; color: #fff !important; }
          .tax-table th { background: #edf5f5 !important; }
          .empty-row td { height: 14px; }
          .developer-credit { font-size: 6px; padding: 2px 8px 3px; }
        }
      `}</style>
    </div>
  );
};

export default PharmacyInvoiceTemplate;